class InitialPackageType {
  SeparateFromPackage() {
    return 0;
  }
  Secretary() {
    return 1;
  }
  IVR() {
    return 2;
  }
  Fax() {
    return 3;
  }
}
export default new InitialPackageType();
